import { motion, useScroll } from "framer-motion";
import { useRef } from "react";
import Nav from "../components/Nav";
import SiteMap from "../components/SiteMap";
import work from "../data/projects";

export default function OurWork() {

    const scroll = useRef(null)
    const m = window.innerWidth < 961;

    const { scrollY } = useScroll({
        container: scroll 
    })

    return (
        <>
            <div  ref={scroll} style={{ height: '100vh', overflowY: 'scroll', overflowX: 'hidden' }}>
                <Nav scrollY={scrollY} noInverse />
                <div id="work-content-wrapper">
                    <motion.h1 style={{ fontSize: 60, margin: m ? "20px 0" : "60px 0px", color: '#fff', textAlign: 'center' }}
                        initial={{ y: 100, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                    >Our Work</motion.h1>
                    <motion.div id="work-list">
                        {work.map((itm, i) => (
                            <motion.div 
                                className="work-card" 
                                style={{ position: 'relative', flexDirection: 'column' }} 
                                key={itm.name} 
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.1 + (0.1 * i) }}
                            >
                                <img 
                                    src={itm.preview}
                                    style={{
                                        width: 200,
                                        aspectRatio: 1,
                                        objectFit: 'contain'
                                    }} 
                                    alt={itm.name}
                                />
                                <h1>{itm.name}</h1>
                                <p>{itm.summary}</p>

                                {(itm.android || itm.ios) && <div className="storebuttons">
                                    <a href={itm.android}><img id="android" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                                    <a href={itm.ios}><img id="apple" alt='Download It In App Store' src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/1200px-Download_on_the_App_Store_Badge.svg.png"/></a>
                                </div>}

                                {itm.website && (
                                    <>
                                        <br />
                                        <button onClick={() => window.open(itm.website, "_blank")}>Visit Site</button>
                                    </>
                                )}
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
                <SiteMap />
            </div>

        </>
    )
}